import { getTargets } from '../constants/targets';
import { WAITING, RERENDER, RENDERING } from '../constants/render';

export default function (doc, options) {
  options = options || {};
  let mustRender = null;
  const currRender = doc.mustRender ? doc.mustRender.asMutable({ deep: true }) : [];
  const TARGETS = getTargets();
  TARGETS.forEach(target => {
    if (doc.chart.targets.indexOf(target.value) != -1) {
      for (let i = 0; i < target.sizes.length; i++) {
        const size = target.sizes[i];
        mustRender = mustRender || currRender;
        if (options.addGroup) {
          if (options.addGroup === size.group) {
            mustRender = mustRender || currRender;
            addRender(size.id, mustRender);
          }
        } else if (options.removeGroup) {
          if (options.removeGroup === size.group) {
            mustRender = mustRender || currRender;
            removeFromGroup(size.id, mustRender);
          }
        } else if (doc.chart.groups.indexOf(size.group) !== -1) {
          mustRender = mustRender || [];
          addRender(size.id, mustRender);
        }
      }
    }
  });
  return mustRender || [];
}

function addRender(id, mustRender) {
  const index = renderIndex(mustRender, id);
  if (index === -1) {
    mustRender.push(newRender(id));
  } else {
    mustRender[index].status = (mustRender[index].status === RENDERING) ?
     RERENDER : WAITING;
  }
  return mustRender;
}

function removeFromGroup(id, mustRender) {
  const index = renderIndex(mustRender, id);
  if (index !== -1) {
    mustRender.splice(index, 1);
  }
  return mustRender;
}

function newRender(id) {
  return { id, status: WAITING, };
}

function renderIndex(mustRender = [], id) {
  for (let i = 0; i < mustRender.length; i++) {
    if (mustRender[i].id === id) {
      return i;
    }
  }
  return -1;
}
